module.exports = __webpack_public_path__ + "media/assets/images/payment/mastercard-2f519fd297fbf30fb27a0c740a94bee8.png";